/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * @returns true if validation passed. An object with the validation id and a message property
 *  inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function decimalValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  let errormsg = '';
  // Condition Checked for object(props.min) throws undefined issue
  if(form.props?.min === 0 || form.props?.min){
    // Check given value greater than min value
    const minValue: number = +form.props.min;
    const isInclusive = (options && options.inclusive && options.inclusive === true) ? true : false;

    // Minimum value can be inclusive / exclusive. By default it's exclusive
    let errorCondition: boolean = false;
    if (isInclusive) {
      errorCondition = (+model < minValue);
    } else {
      errorCondition = (+model <= minValue);
    }

    // Check condition
    if (errorCondition) {
      if (isInclusive) {
        errormsg = "Value should be greater than or equal to "+ form.props.min;
      } else {
        errormsg = "Value should be greater than "+ form.props.min;
      }
    }
  }
  
  return errormsg
  ? {
      decimalValidator: {
        message: errormsg,
      },
    }
  : null;
}